import { api } from "./api";
import { toast } from "sonner";
import { licenseActive } from "./license";
import { openTransfer } from "./transfer";

export const isPremium = (user) => !!(user && (user.role === "admin" || user.is_premium));

// Prueba gratis de 20 días: licencia vigente, aún sin plan pagado ni Pro.
// Incluye TODO ClinGo (ClinFun, ClinBreath, ClinPulse, ClinIV, calculadoras) EXCEPTO el asistente Oci.
export const inTrial = (user) =>
  !!(user && user.role !== "admin" && !user.is_premium && !user.has_paid && licenseActive(user));

// Herramientas premium de ClinGo (ClinPulse, ClinBreath): Pro, prueba o regalo del admin.
export const hasClinTool = (user, giftFlag) =>
  isPremium(user) || inTrial(user) || !!(user && user[giftFlag]);

// Enlaces de pago (Payment Links) de Stripe — cobros reales.
const PAYMENT_LINKS = {
  pro: "https://buy.stripe.com/9B6bJ17OlaOt5jY2BE8og01",     // Plan Pro $400
  base: "https://buy.stripe.com/3cIdR97Ol7Ch3bQ5NQ8og00",    // Plan Básico $150
  dental: "https://buy.stripe.com/8x27sLgkR7ChfYC2BE8og02",  // Plan Odontológico $170
};

// Redirige al enlace de pago agregando el ID del médico para reactivar la licencia
// automáticamente vía webhook al completar el pago.
async function goToPaymentLink(plan) {
  try {
    const { data: user } = await api.get("/auth/me");
    const url = new URL(PAYMENT_LINKS[plan]);
    url.searchParams.set("client_reference_id", user.user_id);
    if (user.email) url.searchParams.set("prefilled_email", user.email);
    window.location.href = url.toString();
  } catch (e) {
    // Si no se pudo iniciar el pago con tarjeta, ofrecemos la alternativa por transferencia.
    toast.error("No se pudo iniciar el pago con tarjeta. Te mostramos otra forma de pagar.");
    openTransfer(plan);
  }
}

export async function startProCheckout() { return goToPaymentLink("pro"); }
export async function startDentalCheckout() { return goToPaymentLink("dental"); }
export async function startBaseCheckout() { return goToPaymentLink("base"); }
